import { Injectable } from '@angular/core';
import { Category } from '../interfaces/category';

@Injectable({
    providedIn: 'root'
})
export class RootService {
    constructor() { }

    home(): string {
        return '/';
    }

    shop(): string {
        return `/shop/catalog`;
    }

    category(category: Partial<Category> | string): string {
        if (!category)
            return this.shop();
        if (typeof category == 'string')
            return `${this.shop()}/${category}`;
        if (category.type === 'shop') {
            const basePath = this.shop();
            if ('slug' in category) {
                return `${basePath}/${category.slug}`;
            }
            if ('id' in category) {
                return `${basePath}/${category.id}`;
            }

            throw Error('Provide category with "path", "slug" or "id".');
        }
        if (category.type === 'blog') {
            return this.blog();
        }

        throw Error('Provided category with unknown type.');
    }

    product(product: any): string {
        const basePath = '/shop/products';

        if (product && product.codart) {
            return `${basePath}/${product.codart}`;
        }

        throw Error('Provide articolo with "cf_azienda" and "codart".');
    }

    cart(): string {
        return '/shop/cart';
    }

    checkout(): string {
        return '/shop/cart/checkout';
    }

    wishlist(): string {
        return '/shop/wishlist';
    }

    blog(): string {
        return '/blog';
    }

    post(): string {
        return `/blog/post-classic`;
    }

    login(): string {
        return '/auth/login';
    }

    terms(): string {
        return '/site/terms';
    }

    notFound(): string {
        return `/site/not-found`;
    }

    collection(id) : string {
        return '/shop/collections/' + id;
    }
}
